<template>
	<div
		class="flex flex-col items-start gap-4 px-4 py-4 border-b border-gray-200 sm:flex-row sm:items-center even:bg-gray-50/50 last:border-none"
	>
		<!-- statement -->
		<p class="flex-1 text-gray-900" v-text="question.text" />
		<!-- Rating buttons -->
		<div
			class="flex justify-center w-full gap-2 sm:w-auto sm:gap-2"
			role="radiogroup"
			:aria-labelledby="`q-${question.id}`"
		>
			<button
				v-for="n in 5"
				:key="n"
				type="button"
				:aria-label="ariaLabel(n)"
				:aria-pressed="modelValue === n"
				class="flex items-center justify-center w-12 h-12 text-sm font-medium transition-colors border rounded-full sm:w-11 sm:h-11 sm:text-base"
				:class="getButtonClass(n)"
				@click="modelValue = n"
			>
				{{ n }}
			</button>
		</div>
	</div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import type { Question } from '../data/learningTest';
import { useWizardStore } from '@/stores/wizard';

const props = defineProps<{ question: Question }>();
const emit = defineEmits<{
	answerChanged: [];
}>();
const store = useWizardStore();

function ariaLabel(n: number) {
	if (n === 1) return 'Trifft gar nicht zu';
	if (n === 5) return 'Trifft voll zu';
	return `Stufe ${n}`;
}

function getButtonClass(n: number) {
	return n == modelValue.value
		? 'bg-blue-600 text-white'
		: 'bg-white hover:bg-blue-600 hover:text-white text-gray-600 border';
}

const modelValue = computed({
	get: () => store.answers[props.question.id] || 0,
	set: (val: number) => {
		store.setAnswer(props.question.id, val);
		// Emit event to parent for auto-scroll functionality
		emit('answerChanged');
	},
});
</script>
